module.exports = __webpack_public_path__ + "static/img/tech1.c91474ff.png";